module.exports = __webpack_public_path__ + "media/images/stripe_grey-94f524cdb67f7d920b5360ccc9979dcb.png";